module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Regular.eot
// module id = 12
// module chunks = 8